var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoyaltyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 71.52 71.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;stroke:#fff;stroke-width:0.5px;}.cls-2{fill:#d68828;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2210",
    "data-name": "Group 2210"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    "data-name": "Group 38"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    className: "cls-1",
    d: "M36.76,58.23A23.75,23.75,0,1,1,60.51,34.48h0A23.78,23.78,0,0,1,36.76,58.23Zm0-45.22A21.47,21.47,0,1,0,58.23,34.48h0A21.51,21.51,0,0,0,36.76,13Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41",
    "data-name": "Group 41"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    "data-name": "Group 39"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    className: "cls-2",
    d: "M39.89,29.3a70.94,70.94,0,0,0-2.78,16.17.43.43,0,0,0,.38.49.42.42,0,0,0,.37-.13A53.78,53.78,0,0,0,48.45,33.28a4.72,4.72,0,0,0-8.56-4Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40",
    "data-name": "Group 40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    className: "cls-2",
    d: "M33.64,29.3a70.94,70.94,0,0,1,2.78,16.17A.44.44,0,0,1,36,46a.43.43,0,0,1-.37-.13A53.5,53.5,0,0,1,25.08,33.28a4.72,4.72,0,0,1,8.56-4Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoyaltyIcon);
export default __webpack_public_path__ + "static/media/loyalty-icon.e347c5bba57fd512b61441465be34c72.svg";
export { ForwardRef as ReactComponent };